import { Dialog, DialogProps } from '@material-ui/core';
import React from 'react';
import CommunityRepresentative from './CommunityRepresentative';

export default function CommunityRepresentativeModal({ ...props }: DialogProps) {
    return (
        <Dialog
            {...props}
            PaperProps={{
                style: {
                    borderRadius: 18,
                },
            }}
        >
            <CommunityRepresentative modal />
        </Dialog>
    );
}
